"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const tooltip_1 = require("@pulse-web-ui/tooltip");
const react_1 = __importStar(require("react"));
const react_text_mask_1 = require("react-text-mask");
const components_1 = require("./components");
const hint_icon_1 = require("./icons/hint-icon");
const reset_icon_1 = require("./icons/reset-icon");
const input_constants_1 = require("./input.constants");
const input_styles_1 = require("./input.styles");
require("./input.types");
const PHONE_MASK = [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
];
exports.Input = (0, react_1.memo)((0, react_1.forwardRef)((_a, ref) => {
    var { showResetIcon, disabled, hintObject, label, error, placeholder, shrink, value, name, onChange, type = 'text', width, required, hasTooltip, tooltipLabel, tooltipText, to, container, trigger, direction, placement, arrow, icon, closingTimeout, styles, warning, mask, noMargin, onClickIcon, pipe, placeholderChar, sizeType = input_constants_1.InputSizeType.LARGE } = _a, props = __rest(_a, ["showResetIcon", "disabled", "hintObject", "label", "error", "placeholder", "shrink", "value", "name", "onChange", "type", "width", "required", "hasTooltip", "tooltipLabel", "tooltipText", "to", "container", "trigger", "direction", "placement", "arrow", "icon", "closingTimeout", "styles", "warning", "mask", "noMargin", "onClickIcon", "pipe", "placeholderChar", "sizeType"]);
    const [inputType, setInputType] = (0, react_1.useState)(type);
    const reset = showResetIcon && !disabled && Boolean((value === null || value === void 0 ? void 0 : value.length) > 0);
    const [hideLabel, setHideLabel] = (0, react_1.useState)(false);
    const labelText = (0, react_1.useMemo)(() => (hideLabel || (sizeType === 'm' && value) ? '' : label), [sizeType, value, hideLabel, label]);
    const handleResetValue = () => {
        onChange && onChange('');
    };
    const handleMouseDown = (0, react_1.useCallback)((e) => {
        e.preventDefault();
    }, []);
    const handleValueChange = (0, react_1.useCallback)((newValue) => {
        value !== newValue && onChange(newValue);
    }, [onChange, value]);
    const handleInputOnChange = (0, react_1.useCallback)((event) => {
        var _a;
        return handleValueChange(typeof event === 'string' ? event : (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
    }, [handleValueChange]);
    const handleOnFocusChange = (0, react_1.useCallback)(() => {
        if (sizeType === 'm') {
            setHideLabel(true);
        }
    }, [hideLabel, setHideLabel, sizeType]);
    const handleOnBlurChange = (0, react_1.useCallback)(() => {
        if (sizeType === 'm') {
            setHideLabel(false);
        }
    }, [hideLabel, setHideLabel, sizeType]);
    const getPhonePipeConfig = (config) => {
        const { rawValue } = config;
        if (rawValue.indexOf('+7 ') === 0 || rawValue.indexOf('8 ') === 0) {
            return rawValue.replace('+7 ', '');
        }
    };
    const handlePaste = (e) => {
        e.preventDefault();
        const value = e.clipboardData.getData('text');
        const formattedValue = value.replace(/^(?:\+7|7|8)/, '');
        const { conformedValue } = (0, react_text_mask_1.conformToMask)(formattedValue, PHONE_MASK);
        onChange(conformedValue);
    };
    const hint = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            (hintObject === null || hintObject === void 0 ? void 0 : hintObject.showIcon) && (react_1.default.createElement(input_styles_1.StyledHintIcon, { hasTooltip: hasTooltip, isError: error, sizeType: sizeType }, hasTooltip ? (react_1.default.createElement(tooltip_1.Tooltip, { error: error, tooltipLabel: tooltipLabel, tooltipText: tooltipText, to: to, container: container, trigger: trigger, placement: placement, arrow: arrow, direction: direction, closingTimeout: closingTimeout, styles: styles })) : (react_1.default.createElement(hint_icon_1.HintIcon, { isError: error })))),
            react_1.default.createElement(input_styles_1.StyledHintMessage, { warning: warning, isError: error, noMargin: noMargin && !(hintObject === null || hintObject === void 0 ? void 0 : hintObject.message) }, hintObject === null || hintObject === void 0 ? void 0 : hintObject.message)));
    }, [hintObject, error]);
    const resetComponent = (react_1.default.createElement(input_styles_1.StyledResetIcon, { hintObject: hintObject, onClick: handleResetValue, onMouseDown: handleMouseDown, sizeType: sizeType },
        react_1.default.createElement(reset_icon_1.ResetIcon, { isError: error })));
    const handleShowPassword = () => {
        setInputType(inputType === 'password' ? 'text' : 'password');
    };
    const getIcon = () => {
        if (showResetIcon) {
            return (type !== 'password' &&
                reset &&
                !(hintObject === null || hintObject === void 0 ? void 0 : hintObject.showIcon) &&
                resetComponent);
        }
        if (icon) {
            return (react_1.default.createElement(input_styles_1.StyledButtonIcon, { onClick: onClickIcon, sizeType: sizeType }, icon));
        }
    };
    if (!!mask) {
        return (react_1.default.createElement(input_styles_1.StyledMaskInputWrapper, { width: width },
            react_1.default.createElement(input_styles_1.StyledMaskInput, Object.assign({ warning: warning, required: required, isError: error, value: value, label: labelText, disabled: disabled, onChange: handleInputOnChange, placeholder: placeholder, mask: mask, pipe: pipe, placeholderChar: placeholderChar, onFocus: handleOnFocusChange, onBlur: handleOnBlurChange, sizeType: sizeType }, props)),
            react_1.default.createElement(input_styles_1.StyledInputLabel, { showResetIcon: showResetIcon, value: value, shrink: shrink, isError: error, disabled: disabled, sizeType: sizeType }, labelText),
            reset && !(hintObject === null || hintObject === void 0 ? void 0 : hintObject.showIcon) && resetComponent,
            hint));
    }
    if (type === 'tel') {
        return (react_1.default.createElement(input_styles_1.StyledMaskInputWrapper, { width: width },
            react_1.default.createElement(input_styles_1.StyledMaskInput, Object.assign({ type: "tel", warning: warning, required: required, isError: error, value: value, label: labelText, disabled: disabled, onChange: handleInputOnChange, onFocus: handleOnFocusChange, onBlur: handleOnBlurChange, sizeType: sizeType, placeholder: "(000) 000-00-00", mask: PHONE_MASK, onPaste: handlePaste, pipe: (conformedValue, config) => {
                    getPhonePipeConfig(config);
                    return conformedValue;
                } }, props)),
            react_1.default.createElement(input_styles_1.StyledCountryNumber, { value: value, isError: error, disabled: disabled, label: labelText, sizeType: sizeType }, "+7"),
            sizeType === 'l' && (react_1.default.createElement(input_styles_1.StyledInputLabel, { type: "tel", value: value, shrink: shrink, isError: error, disabled: disabled, sizeType: sizeType }, labelText)),
            reset && !(hintObject === null || hintObject === void 0 ? void 0 : hintObject.showIcon) && resetComponent,
            hint));
    }
    return (react_1.default.createElement(input_styles_1.StyledGroup, { width: width },
        react_1.default.createElement(input_styles_1.StyledInput, Object.assign({ warning: warning, hintObject: hintObject, required: required, type: inputType, showResetIcon: showResetIcon, name: name, value: value, label: labelText, isError: error, placeholder: placeholder, disabled: disabled, ref: ref, onChange: handleInputOnChange, onFocus: handleOnFocusChange, onBlur: handleOnBlurChange, sizeType: sizeType }, props)),
        react_1.default.createElement(input_styles_1.StyledInputLabel, { showResetIcon: showResetIcon, value: value, shrink: shrink, isError: error, disabled: disabled, sizeType: sizeType }, labelText),
        getIcon(),
        type === 'password' && !(hintObject === null || hintObject === void 0 ? void 0 : hintObject.showIcon) && (react_1.default.createElement(components_1.ShowPasswordComponent, { showPassword: handleShowPassword, type: inputType, isError: error })),
        hint));
}));
